import { createType } from 'framework/utils/createType';

export const HandoverLineModes = createType('exclude', 'refundable', 'nonRefundable');
export type HandoverLineMode = typeof HandoverLineModes[number];
